export const FORMAT = {
  DATE_YEAR: "MMM dd', 'yyyy",
  DATETIME_FORMAT: 'MM/dd/yyyy HH:mm',
} as const;
